<template>
  <div class="form container">
    <div class="form-register formResponsive">
      <span class="tit">Log In</span>
      <br />
      <br />
      <div>
        <label class="inline">E-mail Address</label>
        <input class="inline" v-model="login.email" type="text" name />
      </div>
      <div>
        <label class="inline">Password</label>
        <input class="inline" v-model="login.password" type="password" name />
      </div>
      <input type="submit" value="Log In" @click="validateLogin()" />
      <br />
      <br />
      <p class="validation">{{ loginValidation }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      login: {
        username: "",
        email: "",
        password: ""
      },
      loginValidation: ""
    };
  },
  methods: {
    validateLogin: function(value) {
      this.login.username = this.login.email;
      this.axios
        .post(process.env.API_BASE_URL + "/login", this.login)
        .then(response => {
          if (response.data.error) {
            console.error(response.data.error);
            this.loginValidation = response.data.error;
          } else {
            this.$store.dispatch("login", response.data).then(() => {
              const redirectPath = this.$route.query.redirect;
              if (redirectPath) {
                this.$router.push(redirectPath);
              } else {
                this.$emit("showFormChanged");
              }
            });
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// Login.vue?a304e584